import { Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { H6 } from "../../../../../../AbstractElements";
import { BasicRadioAndCheckboxTitle } from "../../../../../../Constants/Constants";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BasicCheckboxRadioData, BasicRadioAndCheckBoxSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormControls";

const BasicRadioAndCheckbox = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={BasicRadioAndCheckboxTitle} span={BasicRadioAndCheckBoxSubTitle} />
        <CardBody>
          <Row className="g-3">
            {BasicCheckboxRadioData.map((data) => (
              <Col md="12" key={data.id}>
                <div className="card-wrapper border rounded-3 checkbox-checked">
                  <H6 className="sub-title">{data.title}</H6>
                  <div className="form-check-size">
                    {data.child.map((item) => (
                      <FormGroup key={item.id} className={item.formGroupClass} check inline>
                        <Input id={`inline-${item.id}`} type={item.type} defaultChecked={item.check === "checked"} name={item.type === "radio" ? item.name : ""} />
                        <Label htmlFor={`inline-${item.id}`} check>
                          {item.text}
                        </Label>
                      </FormGroup>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicRadioAndCheckbox;
